import {
  GET_CLUB_MEMBERSHIP_SUCCESS,
  CLUB_MEMBERSHIP_OBJECT_REQUESTING,
  CLUB_MEMBERSHIP_LIST_REQUESTING,
  LIST_CLUB_MEMBERSHIPS_SUCCESS,
  RESET_CLUB_MEMBERSHIP_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  isObjectFetching: false,
  query: null,
  recordCount: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CLUB_MEMBERSHIP_ISFETCHING: {
      return {
        ...state,
        isListFetching: false,
        isObjectFetching: false
      };
    }

    case CLUB_MEMBERSHIP_LIST_REQUESTING: {
      return {
        ...state,
        isListFetching: true
      };
    }
    case CLUB_MEMBERSHIP_OBJECT_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }
    case LIST_CLUB_MEMBERSHIPS_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.clubMemberships.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        ...state,
        data,
        query,
        recordCount: action.payload.total,
        isListFetching: false
      };
    }
    case GET_CLUB_MEMBERSHIP_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        ...state,
        data,
        isObjectFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getActiveAndOnHoldClubMemberships = (clubMembership) => {
  if (!clubMembership.data) {
    return null;
  }
  const clubMembershipIds = Object.keys(clubMembership.data);
  const activeIds = clubMembershipIds.filter(
    (id) =>
      clubMembership.data[id].status === 'Active' ||
      clubMembership.data[id].status === 'On Hold'
  );
  return activeIds.map((id) => clubMembership.data[id]);
};

export const getCancelledClubMemberships = (clubMembership) => {
  if (!clubMembership.data) {
    return null;
  }
  const clubMembershipIds = Object.keys(clubMembership.data);
  const cancelledIds = clubMembershipIds.filter(
    (id) => clubMembership.data[id].status === 'Cancelled'
  );
  return cancelledIds.map((id) => clubMembership.data[id]);
};
